export default "__VITE_ASSET__R3In63J3__"